<template>
  <div>
    <a-form
      layout="horizontal"
      @submit="handleSubmit"
      :autoFormCreate="(form) => (this.form = form)"
      class="form"
      :label-col="{ span: 5 }"
      :wrapper-col="{ span: 12 }"
    >
      <a-form-item
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        label="商品名称"
        fieldDecoratorId="name"
        :fieldDecoratorOptions="{
          rules: [{ required: true, message: '请输入商品名称' }],
          initialValue: goods.name,
        }"
      >
        <a-input placeholder="请输入商品名称" />
        SKU: {{ sku }}
      </a-form-item>
      <a-form-item
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        label="兑换规则"
        fieldDecoratorId="exchange_price"
        :fieldDecoratorOptions="{
          rules: [{ required: true, message: '请输入兑换规则' }],
          initialValue: goods.exchange_price,
        }"
      >
        <a-input-number placeholder="请输入兑换规则" />
      </a-form-item>
      <a-form-item
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        label="分类"
        fieldDecoratorId="category_id"
        :fieldDecoratorOptions="{
          rules: [{ required: true, message: '请选择类别' }],
          initialValue: goods.category_id,
        }"
      >
        <a-select placeholder="请选择类别" allowClear show-search option-filter-prop="children">
          <a-select-option v-for="d in major_categories" :key="d.id">{{
            d.name
          }}</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        label="供应商"
        fieldDecoratorId="supplier_id"
        :fieldDecoratorOptions="{
          rules: [{ required: false, message: '请选择供应商' }],
          initialValue: goods.supplier_id,
        }"
      >
        <a-select placeholder="请选择供应商" allowClear show-search option-filter-prop="children">
          <a-select-option v-for="d in suppliers" :key="d.id">{{
            d.name
          }}</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        label="商品图片"
        fieldDecoratorId="pic_url"
        :fieldDecoratorOptions="{
          rules: [{ required: true, message: '请上传商品图片' }],
          initialValue: goods.pic_url,
        }"
      >
        <a-upload
          name="file"
          listType="picture-card"
          class="avatar-uploader"
          :showUploadList="false"
          action="//upload.qiniup.com"
          :beforeUpload="beforeCoverUpload"
          :data="imgForm"
          @change="handleCoverChange"
        >
          <img width="128" height="128" v-if="pic_url" :src="pic_url" />
          <div v-else>
            <a-icon :type="loading ? 'loading' : 'plus'" />
            <div class="ant-upload-text">上传</div>
          </div>
        </a-upload>
      </a-form-item>
      <a-form-item
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        label="是否零售"
        fieldDecoratorId="is_retail"
        :fieldDecoratorOptions="{
          rules: [{ required: true, message: '请选择类别' }],
          initialValue: goods.is_retail,
        }"
      >
        <a-select placeholder="请选择">
          <a-select-option :key="true">是</a-select-option>
          <a-select-option :key="false">否</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        label="零售价格"
        fieldDecoratorId="retail_price"
        :fieldDecoratorOptions="{ initialValue: goods.retail_price }"
      >
        <a-input-number />
      </a-form-item>
      <a-form-item
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        label="69码"
        fieldDecoratorId="barcode69"
        :fieldDecoratorOptions="{ initialValue: goods.barcode69 }"
      >
        <a-input />
      </a-form-item>
      <a-card class="card" :bordered="false">
        <a-row>
          <a-col :span="4" :offset="10">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-button type="primary" htmlType="submit">提交</a-button>
            </a-form-item>
          </a-col>
        </a-row>
      </a-card>
    </a-form>
  </div>
</template>
<script>
import Tinymce from "@/components/Tinymce";
import { getCategoryList } from "@/api/category";
import { getQiniuToken } from "@/api/qiniu";
import { editGoods } from "@/api/goods";
import { getSupplierList } from "@/api/supplier";

export default {
  name: "AddGoods",
  components: {
    Tinymce,
  },
  data() {
    return {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      loading: false,
      imgForm: {},
      bucketHost: "",
      fileList: [],
      listObj: [],
      form: null,
      pic_url: "",
      sku: "",
      major_categories: [], // 主分类列表
      suppliers: [],
      skus: [],
      goods: {}, //商品信息
    };
  },
  created() {
    // console.log(this.$route.params)
    this.initPagge();
    this.getCategoryList();
    this.getSupplierList();
  },
  methods: {
    initPagge: function () {
      const {
        id,
        name,
        exchange_price,
        category_id,
        supplier_id,
        pic_url,
        is_retail,
        retail_price,
        barcode69
      } = this.$route.params || {};
      if (id) {
        this.goods = {
          is_retail: false,
        };
      } else {
        this.pic_url = pic_url;
        this.goods = {
          id,
          name,
          exchange_price,
          category_id,
          supplier_id,
          pic_url,
          is_retail,
          retail_price,
          barcode69,
        };
      }
    },
    getCategoryList: function () {
      getCategoryList({ page_size: 10000 }).then((res) => {
        this.major_categories = res.list;
      });
    },
    getSupplierList() {
      getSupplierList({ page_size: 10000 }).then((res) => {
        this.suppliers = res.list;
      });
    },
    handleSubmit(e) {
      e.preventDefault();
      const vm = this;
      vm.form.validateFields((err, values) => {
        if (!err) {
          if (values.is_retail && values.retail_price <= 0) {
            vm.$message.error("零售价格不能为空");
            return;
          }
          values.pic_url = vm.pic_url;
          values.retail_price = values.retail_price || 0
          editGoods(values).then((res) => {
            vm.$message.success("添加成功");
            vm.form.resetFields();
          });
        }
      });
    },
    beforeCoverUpload: function () {
      let _this = this;
      return getQiniuToken().then((res) => {
        _this.bucketHost = res.bucket_host;
        _this.imgForm = {
          // key: res.key,
          token: res.qiniu_token,
        };
      });
    },
    handleCoverChange(info) {
      if (info.file.status === "uploading") {
        this.loading = true;
      } else if (info.file.status === "done") {
        let key = info.file.response.key;
        this.pic_url = `${this.bucketHost}${key}`;
        this.loading = false;
      } else if (info.file.status === "error") {
        this.loading = false;
        this.$message.error("上传图片失败，请重试");
      } else if (info.file.status === "removed") {
        console.log("removed");
      }
    },
  },
};
</script>

<style lang="less">
.addable-add-btn {
  margin-bottom: 10px;
}
</style>
